<template>
  <main>
    <section id="parallax" class="section--full" @mousemove="parallax">
      <video autoplay muted loop playsinline class="section__video">
        <source src="@/assets/video/home.mp4" type="video/mp4">
      </video>
      <!-- <img class="image-banner" src="@/assets/images/header_desktop.jpg" alt=""> -->
      <div id="banner-text" class="banner-title test-heading description">
        <span class="heading-home">Celebrating <br>
         the 32nd anniversary of MNC Group</span>,
        <span>we're delighted to invite you to explore and enjoy our month-long digital activites!</span>
      </div>
    </section>
    <section class="section--half responsive">
      <div class="container">
        <div id="content-hover" class="flex">
          <div>
            <!-- <button  @click="dropIt" class="btn-explore"> -->
            <div class="btn-explore">
              <img src="@/assets/images/icon_scroll-08.png" alt="">
              Scroll to explore
            </div>
          </div>
          <div id="logo_ig">
            <a target="_blank" href="https://www.instagram.com/mncfest2021/">
              <img class="logo_ig" src="@/assets/images/ig.png" alt="">
            </a>
          </div>
        </div>
      </div>
    </section>
    <!-- <section id="menu-hover" class="section--half responsive" v-if="othersMenu" v-bind:class="{sectionHeight : othersMenu}"> -->
    <section id="menu-hover" class="section--half responsive sectionHeight">
        <div class="container grid">
            <ul id="list" class="list list-animation">
              <li @mouseenter="displayChange($event)" class="list__item animation active">
                <router-link class="display-block" to="/kiko-run">
                  Kiko Run Competition
                </router-link>
              </li>
                <li @mouseenter="displayChange($event)" class="list__item animation">
                  <router-link class="display-block" to="/parade-live">
                    Live Shopping Parade
                  </router-link>
                </li>
                <li  @mouseenter="displayChange($event)" class="list__item animation">
                  <router-link class="display-block" to="/digital-career">
                    MNC Digital Career Fest
                  </router-link>
                </li>
                <li @mouseenter="displayChange($event)" class="list__item animation">
                  <router-link class="display-block" to="/tech-forum">  
                    MNC Tech Forum
                  </router-link>
                </li>
                <li @mouseenter="displayChange($event)" class="list__item animation">
                  <router-link class="display-block" to="/motion-tech">
                    MotionTech Launch
                  </router-link>
                </li>
                <li @mouseenter="displayChange($event)" class="list__item animation">
                  <router-link class="display-block" to="/nyapit-cuan">
                    Nyapit Cuan #2
                  </router-link>
                </li>
                <li @mouseenter="displayChange($event)" class="list__item animation">
                  <router-link class="display-block" to="/virtual-hangout"> 
                    Virtual Hangout & Video Challange by Klaklik
                  </router-link>
                </li>
                <li @mouseenter="displayChange($event)" class="list__item animation">
                  <router-link class="display-block" to="/content-creator">
                    Content Creator Performances by MNC Stars
                  </router-link>
                </li>
                <li @mouseenter="displayChange($event)" class="list__item animation">
                  <router-link class="display-block" to="/visions-plus">
                    Watch & Win - Vision+ Original Series
                  </router-link>
                </li>
                <li @mouseenter="displayChange($event)" class="list__item animation">
                  <router-link class="display-block" to="/rcti-plus"> 
                    RCTI+ Special Programs
                  </router-link>
                </li>
                <li @mouseenter="displayChange($event)" class="list__item animation">
                  <router-link class="display-block" to="/csr-mnc"> 
                    CSR For Covid-19
                  </router-link>
                </li>
                <li @mouseenter="displayChange($event)" class="list__item animation">
                  <router-link class="display-block" to="/onair-concert"> 
                    On Air Concert - Anniversary Celebration
                  </router-link>
                </li>
            </ul>
          <div class="hover-animation image-animation">
            <KikoRun v-if="showDisplay == 'Kiko Run Competition'"/>
            <Parade v-if="showDisplay == 'Live Shopping Parade'"/>
            <Digital v-if="showDisplay == 'MNC Digital Career Fest'"/>
            <Nyapit v-if="showDisplay == 'Nyapit Cuan #2'"/>
            <Visions v-if="showDisplay == 'Watch & Win - Vision+ Original Series'"/>
            <Tech v-if="showDisplay == 'MNC Tech Forum'"/>
            <Content v-if="showDisplay == 'Content Creator Performances by MNC Stars'"/>
            <Virtual v-if="showDisplay == 'Virtual Hangout & Video Challange by Klaklik'" />
            <Motion v-if="showDisplay == 'MotionTech Launch'" />
            <Rcti v-if="showDisplay == 'RCTI+ Special Programs'" />
            <Csr v-if="showDisplay == 'CSR For Covid-19'" />
            <Onair v-if="showDisplay == 'On Air Concert - Anniversary Celebration'" />
          </div>
        </div>
    </section>
    <section class="section--half">
      <div class="container">
        <h2 class="heading-home">Schedule</h2>
        <div id="rundown" class="details grid grid--three">
          <div class="rundown">
            <div class="details rundown-one">
              <label class="rundown__label">18 - 30 Oktober 2021</label>
              <router-link to="nyapit-cuan">
                <p class="rundown__description description">Nyapit Cuan #2 - Registration Period</p>
              </router-link>
            </div>
            <div class="details rundown-one">
              <label class="rundown__label">20 Oktober - 15 November 2021</label>
              <router-link to="/virtual-hangout">
                <p class="rundown__description description">Klaklik Video Challenge - Submission Period</p>
              </router-link>
            </div>
            <div class="details rundown-one">
              <label class="rundown__label">25 - 31 Oktober 2021</label>
              <router-link to="/visions-plus">
                <p class="rundown__description description">Watch & Win - Vision+ Original Series</p>
              </router-link>
            </div>
            <div class="details rundown-one">
              <label class="rundown__label">30 Oktober - 6 November 2021</label>
              <router-link to="/content-creator">
                <p class="rundown__description description">Content Creator Performances by MNC Stars</p>
              </router-link>
            </div>
            <div class="details rundown-one">
              <label class="rundown__label">31 Oktober - 5 November 2021</label>
              <router-link to="/virtual-hangout">
                <p class="rundown__description description">Klaklik Virtual Hangout with MNC Stars</p>
              </router-link>
            </div>
            <div class="details rundown-one">
              <label class="rundown__label">1 - 4 November 2021</label>
              <router-link to="/parade-live">
                <p class="rundown__description description">Live Shopping Parade - eMSop, theFthing, AladinMall</p>
              </router-link>
            </div>
           
          </div>
           <div class="rundown">
            <div class="details rundown-two">
              <label class="rundown__label">1 - 4 November 2021</label>
              <router-link to="/nyapit-cuan">
                <p class="rundown__description description">Nyapit Cuan #2 - Competition Period</p>
              </router-link>
            </div>
            <div class="details rundown-two">
              <label class="rundown__label">1 - 6 November 2021</label>
              <router-link to="/kiko-run">
                <p class="rundown__description description">Kiko Run Competition - Periode 1</p>
              </router-link>
            </div>
            <div class="details rundown-two">
              <label class="rundown__label">2 November 2021</label>
              <router-link to="/motion-tech">
                <p class="rundown__description description">MotionTech Launch</p>
              </router-link>
            </div>
            <div class="details rundown-two">
              <label class="rundown__label">1, 4, 6, 7 & 13 November 2021</label>
              <router-link to="/rcti-plus">
                <p class="rundown__description description">RCTI+ Special Live Programs</p>
              </router-link>
            </div>
            <div class="details rundown-two">
              <label class="rundown__label">1 - 30 November 2021</label>
              <router-link to="/digital-career">
                <p class="rundown__description description">MNC Digital Career Fest</p>
              </router-link>
            </div>
          </div>
          <div class="rundown">
            <div class="details rundown-three">
              <label class="rundown__label">3 - 5 November 2021</label>
              <router-link to="/tech-forum">
                <p class="rundown__description description">MNC Tech Forum</p>
              </router-link>
            </div>
            <div class="details rundown-three">
              <label class="rundown__label">6 November 2021</label>
              <router-link to="/onair-concert">
                <p class="rundown__description description">On Air Concert -  Anniversary Celebration</p>
              </router-link>
            </div>
            <div class="details rundown-three">
              <label class="rundown__label">7 - 30 November 2021</label>
              <router-link to="/kiko-run">
                <p class="rundown__description description">Kiko Run Competition - Periode 2</p>
              </router-link>
            </div>
            <div class="details rundown-three">
              <label class="rundown__label">18 November 2021</label>
              <router-link to="/virtual-hangout">
                <p class="rundown__description description">Klaklik Video Challenge - Winner Announcement</p>
              </router-link>
            </div>
            <div class="details rundown-three">
              <label class="rundown__label">Juni -  30 Nov 2021</label>
              <router-link to="/csr-mnc">
                <p class="rundown__description description">MNC Peduli - Covid-19 Vaccination Center</p>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

import parallax from '@/commons/parallax.js'

import KikoRun from '@/components/KikoRun.vue'
import Parade from '@/components/Parade.vue'
import Digital from '@/components/Digital.vue'
import Nyapit from '@/components/Nyapit.vue'
import Visions from '@/components/Visions.vue'
import Tech from '@/components/Tech.vue'
import Content from '@/components/Content.vue'
import Virtual from '@/components/Virtual.vue'
import Motion from '@/components/Motion.vue'
import Rcti from '@/components/Rcti.vue'
import Csr from '@/components/Csr.vue'
import Onair from '@/components/Onair.vue'

export default {
  name: 'Home',
  components: {
    KikoRun,
    Parade,
    Digital,
    Nyapit,
    Visions,
    Tech,
    Content,
    Virtual,
    Motion,
    Rcti,
    Csr,
    Onair
  },
  data() {
    return {
      showDisplay: 'Kiko Run Competition',
      othersMenu: false,

    }
  },
  mounted() {
    this.startAnimations();
    this.rundownAnimations();
  } ,
  methods: {
    displayChange(event) {
      const listItem = document.querySelectorAll('#list')
      // console.log('hover', event)
      // console.log('list', listItem)

      listItem[0].childNodes.forEach(item => {
        if (item.classList.contains('active')) {
          item.classList.remove('active')
        }
      });

      this.showDisplay = event.target.innerText
      event.target.classList.add('active')
    },
    // dropIt() {
    //   console.log('dropIt')
    //   this.othersMenu = !this.othersMenu

    //   this.showDisplay = 'Kiko Run'
    // },
    parallax(e) {
      const elem = document.querySelector("#parallax > video")

      elem.style.top = parallax.parallaxAnimation(e).vidY;
      elem.style.left = parallax.parallaxAnimation(e).vidX;
    
    },
    startAnimations() {
      gsap.fromTo('#banner-text',
        {x: -100 , opacity: 0}, 
        {duration: .8, x: 0, opacity: 1}
      )

      const tc = gsap.timeline()

      tc.fromTo('.animation', 
        {x:-100 , opacity: 0},
        {stagger: 0.2 , duration:.4 , x: 0 , opacity: 1}
      )
      .fromTo('.image-animation', 
        {x: 100 , opacity: 0},
        {duration: .8 , x: 0 , opacity: 1}, "-=2.5"
      )

      ScrollTrigger.create({
        trigger: '#content-hover',
        animation: tc,
        start: 'top center'
      })
    },
    rundownAnimations() {
      const tl = gsap.timeline()

      tl.fromTo('.rundown-one',
        {y:100 , opacity:0},
        {stagger: 0.3, duration: .5 ,y:0 , opacity: 1}, "-=.5"
      )
      .fromTo('.rundown-two',
        {y:100 , opacity:0},
        {stagger: 0.3, duration: .5 ,y:0 , opacity: 1}, "-=2"
      )
      .fromTo('.rundown-three',
        {y:100 , opacity:0},
        {stagger: 0.3, duration: .5 ,y:0 , opacity: 1}, "-=2"
      )
      
      ScrollTrigger.create({
        trigger: '#rundown',
        animation: tl,
        start: 'top center'
      })
    }
  }
}
</script>
